import React from 'react';

import Settings from '../settings';

const { $ } = window;

export default class SettingsDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.getSettings(props);
    this.state.toolbar = props.toolbar;

    this.state.fontsListLoaded = false;
    this.state.fontsList = this.state.availableFonts;
    window.populateFontList = (fonts) => {
      fonts.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
      this.setState({
        fontsListLoaded: true,
        fontsList: fonts
      });
    }
  }

  getSettings(props) {
    let project = (props ? props.toolbar : this.state.toolbar.state.project);
    return {
      projectName: (project && project.name) ? project.name : 'lator',

      cleanAccuracy: Settings.get('clean-accuracy', 7),
      cleanMargin: Settings.get('clean-margin', 2),
      cleanFillStyle: Settings.get('clean-fill-style', 'simple'),
      cleanBlurRadius: Settings.get('clean-blur-radius', 10),

      autosave: Settings.get('autosave', 1),

      textRenderingMethod: Settings.get('text-rendering-method', 'advanced'),

      availableFonts: Settings.get('available-fonts', ['Arial', 'Tahoma', 'Times New Roman'].join("\n"))
    };
  }

  componentDidMount() {
    $('#settings.ui.modal').modal({
      onHidden: () => this.hide(),
      onApprove: () => this.save()
    });
    $('[data-content]').popup();
  }

  componentWillReceiveProps(props) {
    if (props.visible) {
      this.setState(this.getSettings());
    }
  }

  componentDidUpdate() {
    $('#settings.ui.modal').modal(this.props.visible ? 'show' : 'hide');
  }

  save() {
    let state = this.state;

    if (this.state.toolbar && this.state.toolbar.state.project) {
      this.state.toolbar.state.project.name = state.projectName;
    }

    Settings.set('clean-accuracy', state.cleanAccuracy);
    Settings.set('clean-margin', state.cleanMargin);
    Settings.set('clean-fill-style', state.cleanFillStyle);
    Settings.set('clean-blur-radius', state.cleanBlurRadius);

    Settings.set('autosave', state.autosave);

    Settings.set('text-rendering-method', state.textRenderingMethod);

    Settings.set('available-fonts', state.availableFonts);

    this.hide();
  }

  hide() {
    this.state.toolbar.setState({
      showSettingsDialog: false
    });
  }

  update(e) {
    let data = {};
    if (e.target.type == 'checkbox') {
      data[e.target.name] = e.target.checked ? 1 : 0;
    } else {
      data[e.target.name] = e.target.value;
    }
    this.setState(data);
  }

  setFontsList(e) {
    e.preventDefault();
    e.stopPropagation();

    this.setState({
      availableFonts: this.state.fontsList.join("\n")
    });
  }

  render() {
    return (
      <div className="ui modal" id="settings">
        <div className="header">
          Настройки
        </div>
        <div className="content">
          <div className="ui form">
            <div className="field">
              <label>Название проекта:</label>
              <input type="text" name="projectName" value={this.state.projectName} onChange={this.update.bind(this)} />
            </div>
            <div className="fields">
              <div className="four wide field">
                <label>Допуск</label>
                <input type="number" min="1" max="255" name="cleanAccuracy" value={this.state.cleanAccuracy} onChange={this.update.bind(this)} />
              </div>
              <div className="four wide field">
                <label>Отступ по краям</label>
                <input type="number" min="0" name="cleanMargin" value={this.state.cleanMargin} onChange={this.update.bind(this)} />
              </div>
              <div className="four wide field">
                <label>Заливка</label>
                <select className="ui fluid dropdown" name="cleanFillStyle" value={this.state.cleanFillStyle} onChange={this.update.bind(this)} data-content="Простая заливает регион одним цветом. Умная умеет работать с градиентным фоном, но она медленнее и может вызывать артефакты.">
                  <option value="simple">простая</option>
                  <option value="smart">умная</option>
                </select>
              </div>
              <div className="four wide field">
                <label>Радиус сглаживания</label>
                <input type="number" min="0" name="cleanBlurRadius" value={this.state.cleanBlurRadius} onChange={this.update.bind(this)} data-content="Только для умной заливки" />
              </div>
            </div>
            <div className="field">
              <div className="ui checkbox">
                <input type="checkbox" name="autosave" value="1" checked={this.state.autosave != 0} onChange={this.update.bind(this)} />
                <label>Автосохранение</label>
              </div>
            </div>
            <div className="field">
              <div style={{float: 'right'}}>
                {this.state.fontsListLoaded &&
                  <small>
                    <a href="#" onClick={this.setFontsList.bind(this)}>заполнить</a>
                  </small>
                }
                {!this.state.fontsListLoaded &&
                  <span>
                    <small>Требуется Flash. Нажмите на квадратик справа: </small>
                    <object type="application/x-shockwave-flash" data="FontList.swf" width="16" heigth="16" style={{width: '16px', height: '16px', outline: 'solid 1px #000', float: 'right', marginLeft: '4px'}}>
                      <param name="movie" value="FontList.swf" />
                      <embed src="FontList.swf" width="16" height="16" />
                    </object>
                  </span>
                }
              </div>
              <label>Доступные шрифты</label>
              <textarea name="availableFonts" value={this.state.availableFonts} onChange={this.update.bind(this)} />
            </div>
          </div>
        </div>
        <div className="actions">
          <button className="ui right primary approve button">Ок</button>
        </div>
      </div>
    );
  }
}
